const APP_URL = "https://images.okepas.com";
const galleryContainer = document.getElementById("galleryContainer");
const loader = document.querySelector(".loading-images");
const paginationContainer = document.getElementById("pagination-controls");

let currentPage = 1;
const limitPerPage = 10;

async function fetchMostLoved(page = 1) {
  loader.style.display = "block";
  galleryContainer.innerHTML = "";

  try {
    const response = await fetch(`${APP_URL}/api/most-loved?page=${page}&limit=${limitPerPage}`);
    const result = await response.json();
    const images = result.data;
    const pagination = result.pagination;

    loader.style.display = "none";

    if (!images || images.length === 0) {
      galleryContainer.innerHTML = "<p>No images found.</p>";
      return;
    }

    images.forEach((fav) => {
      const imgElement = document.createElement("span");
      imgElement.className = "gallery-item image-container";
      imgElement.innerHTML = `
        <img src="${fav.image_src}" alt="Favourite image" />
        <button class="add-button remove-button" data-id="${fav.image_id}">Remove</button>
        <div class="loader" style="display: none;"></div>
      `;

      const removeBtn = imgElement.querySelector('.remove-button');
      removeBtn.addEventListener('click', () => {
        removeFromloved(fav.image_id, removeBtn);
      });

      galleryContainer.appendChild(imgElement);
    });

    renderPaginationControls(pagination);

  } catch (error) {
    loader.style.display = "none";
    console.error("Failed to load images:", error);
    galleryContainer.innerHTML = "<p>Error loading images.</p>";
  }
}

function renderPaginationControls(pagination) {
  paginationContainer.innerHTML = "";

  for (let i = 1; i <= pagination.totalPages; i++) {
    const button = document.createElement("button");
    button.textContent = i;
    button.className = i === pagination.page ? "active-page" : "";
    button.addEventListener("click", () => {
      currentPage = i;
      fetchMostLoved(currentPage);
    });
    paginationContainer.appendChild(button);
  }
}

function removeFromloved(assetId, button) {
  if (!confirm("Are you sure you want to remove this?")) return;

  const span = button.closest("span");
  const perImageLoader = span.querySelector(".loader");
  perImageLoader.style.display = "block";

  const url = `${APP_URL}/api/most-loved/delete/${assetId}`;
  fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
    .then(res => res.json())
    .then(data => {
      perImageLoader.style.display = "none";
      if (data.status) {
        span.remove();
        alert("Image removed successfully");
        fetchMostLoved(currentPage); // reload page after removal
      } else {
        alert("Failed to remove");
      }
    })
    .catch(err => {
      perImageLoader.style.display = "none";
      console.error("Remove failed:", err);
      alert("Something went wrong");
    });
}

document.addEventListener("DOMContentLoaded", () => {
  fetchMostLoved(currentPage);
});
